'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FieldViewEditable = require('./FieldViewEditable');

var _FieldViewEditable2 = _interopRequireDefault(_FieldViewEditable);

var _FieldViewStatic = require('./FieldViewStatic');

var _FieldViewStatic2 = _interopRequireDefault(_FieldViewStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// The preview of a field value. Used for really simple text fields.
function FieldView(_ref) {
  var className = _ref.className,
      isEditable = _ref.isEditable,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ['className', 'isEditable', 'value']);

  var cssClasses = {
    'editable-click': isEditable,
    'editable-empty': (0, _isEmpty3.default)(value),
    'form-value': true
  };
  var PreviewEl = isEditable ? _FieldViewEditable2.default : _FieldViewStatic2.default;
  var editableProps = (0, _pick3.default)(props, 'emptyText', 'id', 'initialValue', 'onClick');
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(cssClasses, className) },
    _react2.default.createElement(PreviewEl, _extends({}, editableProps, { value: value }))
  );
}
FieldView.defaultProps = {
  className: null,
  emptyText: 'Empty',
  isEditable: true,
  value: null
};
FieldView.propTypes = {
  className: _propTypes2.default.string,
  emptyText: _propTypes2.default.string,
  isEditable: _propTypes2.default.bool.isRequired,
  value: _propTypes2.default.string
};

exports.default = FieldView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldViewEl.js
// module id = 680
// module chunks = 0